var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.pageIsLoading)?_c('div',{attrs:{"id":"app"}},[(_vm.showAdminBar)?_c('AdminBar'):_vm._e(),_c('ThemeHeader'),(!_vm.is404)?[_c('transition',{attrs:{"name":"opacity"}},[_c('router-view',{key:_vm.key})],1)]:[_c('Page404')],_c('ThemeFooter')],2):_c('div',[_vm._v("Loading ...")])
}
var staticRenderFns = []

export { render, staticRenderFns }